class TKReveal {
  constructor() {
    this.items = document.querySelectorAll('[data-tk-reveal]');
    if (!this.items.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.items.forEach((item) => item.classList.add('is-visible'));
      return;
    }
    document.documentElement.classList.add('tk-js');
    this.observer = new IntersectionObserver(
      (entries) => entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          this.observer.unobserve(entry.target);
        }
      }),
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
    this.items.forEach((item) => this.observer.observe(item));
  }
}

const initTKPremium = () => new TKReveal();
document.addEventListener('DOMContentLoaded', initTKPremium);
document.addEventListener('shopify:section:load', initTKPremium);
